// store/modules/competition_list.js

export default {
    namespaced: true,
    state: () => ({
        competitionList: []
    }),
    mutations: {
        setMutCompetitionList(state, competitions) {
            state.competitionList = competitions;
        },
        updateMutCompetitionList(state, updatedCompetition) {
            if (!updatedCompetition || !updatedCompetition.id) return;
            const index = state.competitionList.findIndex(u => u.id === updatedCompetition.id);
            if (index !== -1) {
                const current = state.competitionList[index];
                const safeMerge = Object.keys(updatedCompetition).reduce((acc, key) => {
                    if (updatedCompetition[key] !== undefined && updatedCompetition[key] !== null) {
                        acc[key] = updatedCompetition[key];
                    }
                    return acc;
                }, { ...current });
                state.competitionList[index] = safeMerge;
            } else {
                state.competitionList.push(updatedCompetition);
            }
        },
        resetCompetitionList(state) {
            state.competitionList = [];
        }
    },
    actions: {
        setCompetitionList({ commit }, competitions) {
            commit('setMutCompetitionList', competitions);
        },
        updateCompetitionList({ commit }, updatedCompetition) {
            commit('updateMutCompetitionList', updatedCompetition);
        },
        clearCompetitionList({ commit }) {
            commit('resetCompetitionList');
        }

    },
    getters: {
        getCompetitionList: state => state.competitionList,
        getCompetitionListById: state => id =>
            state.competitionList.find(u => u.id === id)
    }
};